import React from 'react'

function FlightLoader() {
  return (
    <div>
            <div className="fullPageLoader v2Loader"><div className="loadingContent"><div className="fliListLdr"><div className="fliListLdrWrap"><div><div className="fliListSmallLineLdr"><p className="fliListLineLdr"></p></div><div className="fliListBigLineLdr"><p className="fliListLineLdr"></p></div></div><span className="fliListLdrIcon"></span></div></div><p className="blackFont fontSize22 textCenter appendTop65">Hold on, we’re fetching flights for you</p></div></div>

    </div>
  )
}

export default FlightLoader
